import { transliterate } from 'transliteration';

// «й»/«ё»/«э» считаются той же буквой, что «и»/«е»
const foldLetters = (value: string) => value.toLowerCase().replace(/й/g, 'и').replace(/[ёэ]/g, 'е');
const hasCyrillic = (value: string) => /[а-яё]/i.test(value);
const hasLatin = (value: string) => /[a-z]/i.test(value);
const hasOtherScriptLetters = (value: string) => /(?=[^\p{ASCII}а-яёА-ЯЁ])\p{L}/u.test(value);

const transliterateUnique = (values: string[]) =>
    [...new Set(values.map((value) => transliterate(value)))].filter(Boolean);

interface SearchQueryPart {
    rawPart: string;
    foldedPart: string;
    foldedTransliteratedParts: string[];
    crossScriptTransliteratedParts: string[];
}

export const buildSearchQueryParts = (query: string): SearchQueryPart[] =>
    query
        .toLowerCase()
        .trim()
        .split(' ')
        .filter(Boolean)
        .map((rawPart) => {
            const foldedPart = foldLetters(rawPart);
            return {
                rawPart,
                foldedPart,
                foldedTransliteratedParts: transliterateUnique([foldedPart]),
                crossScriptTransliteratedParts: transliterateUnique([foldedPart, rawPart]),
            };
        });

export const matchesDisplayName = (displayName: string, queryParts: SearchQueryPart[]): boolean => {
    const lowerName = displayName.toLowerCase();
    const foldedName = foldLetters(lowerName);
    let transliteratedNames: Maybe<string[]>;
    return queryParts.every(({ rawPart, foldedPart, foldedTransliteratedParts, crossScriptTransliteratedParts }) => {
        if (foldedName.includes(foldedPart)) return true;
        const isCrossScript =
            (hasCyrillic(rawPart) && hasLatin(displayName)) || (hasLatin(rawPart) && hasCyrillic(displayName));
        if (!isCrossScript && !hasOtherScriptLetters(rawPart) && !hasOtherScriptLetters(displayName)) return false;
        const transliteratedParts = isCrossScript ? crossScriptTransliteratedParts : foldedTransliteratedParts;
        const names = (transliteratedNames ??= transliterateUnique([foldedName, lowerName]));
        return transliteratedParts.some((part) => names.some((name) => name.includes(part)));
    });
};
